import React from 'react';

const HeaderSocials = () => {
	return (
		<div className='home__socials'>
			<a
				href='https://www.linkedin.com/in/argie-lumapac/'
				className='home__social-link'
				target='_blank'
				rel='noreferrer'
			>
				<i class='fa-brands fa-linkedin'></i>
			</a>

			<a
				href='https://www.instagram.com/arjxdesigns/'
				className='home__social-link'
				target='_blank'
				rel='noreferrer'
			>
				<i class='fa-brands fa-instagram'></i>
			</a>

			<a
				href='https://www.behance.net/argielumapac/'
				className='home__social-link'
				target='_blank'
				rel='noreferrer'
			>
				<i class='fa-brands fa-behance'></i>
			</a>

			<a
				href='https://dribbble.com/arj_designs'
				className='home__social-link'
				target='_blank'
				rel='noreferrer'
			>
				<i class='fa-brands fa-dribbble'></i>
			</a>

			<a
				href='https://github.com/argieeeee'
				className='home__social-link'
				target='_blank'
				rel='noreferrer'
			>
				<i class='fa-brands fa-github'></i>
			</a>
		</div>
	);
};

export default HeaderSocials;
